// extracted by mini-css-extract-plugin
module.exports = {"component_loader":"Helper_component_loader__TaW0m","spin":"Helper_spin__2ThDo"};